import { closeSnackbar, openSnackbar } from "@/store/uiSlice";
import { useAppDispatch } from ".";
import { AlertColor } from "@mui/material";
import { useCallback } from "react";

const useSnackbar = () => {
  const dispatch = useAppDispatch();

  const open = useCallback(
    (message: string, severity: AlertColor = "info") => {
      dispatch(
        openSnackbar({
          severity,
          message,
        })
      );
    },
    [dispatch]
  );

  const close = useCallback(() => {
    dispatch(closeSnackbar());
  }, [dispatch]);

  return [open, close] as const;
};

export default useSnackbar;
